export default class AuditConstants {
    public static AuditPageSize = 20;
}